export default __webpack_public_path__ + "static/media/signin.ba5152fb.svg";